import Immutable from 'immutable';
import { createStructuredSelector } from 'reselect';

import ApiService from 'services/ApiService/ApiService';

import { AVAILABLE_SECURITY_QUESTIONS_URL, SECURITY_QUESTIONS_URL } from './Api';


const AVAILABLE_SECURITY_QUESTIONS = 'cam4/studio/AVAILABLE_SECURITY_QUESTIONS';
const SECURITY_QUESTIONS = 'cam4/studio/SECURITY_QUESTIONS';
const UPDATE_SECURITY_QUESTIONS = 'cam4/studio/UPDATE_SECURITY_QUESTIONS';
const UPDATE_ANSWERS = 'cam4/studio/UPDATE_ANSWERS';

const initialState = Immutable.fromJS({
  availableSecurityQuestions: [],
  securityQuestions: [],
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case AVAILABLE_SECURITY_QUESTIONS:
      return state.set('availableSecurityQuestions', Immutable.fromJS(action.availableSecurityQuestions));

    case SECURITY_QUESTIONS:
      return state.set('securityQuestions', Immutable.fromJS(action.securityQuestions));

    case UPDATE_SECURITY_QUESTIONS:
      return state
        .updateIn(['securityQuestions', action.index, 'id'], () => action.id)
        .updateIn(['securityQuestions', action.index, 'question'], () => action.question)
        .updateIn(['securityQuestions', action.index, 'questionId'], () => action.questionId)
        .updateIn(['securityQuestions', action.index, 'answer'], () => '');

    case UPDATE_ANSWERS:
      return state.updateIn(['securityQuestions', action.index, 'answer'], () => action.value);

    default:
      return state;
  }
}

export const NAME = 'securityQuestions';

const availableSecurityQuestions = (state) => state[NAME].get('availableSecurityQuestions');
const securityQuestions = (state) => state[NAME].get('securityQuestions');

export const selector = createStructuredSelector({
  availableSecurityQuestions,
  securityQuestions,
});

function displaySecurityQuestions(res) {
  return {
    type: SECURITY_QUESTIONS,
    securityQuestions: res.data,
  };
}

function displayAvailableSecurityQuestions(res) {
  return {
    type: AVAILABLE_SECURITY_QUESTIONS,
    availableSecurityQuestions: res.data,
  };
}

function getAvailableSecurityQuestions(callback) {
  return (dispatch) =>
    ApiService.get(AVAILABLE_SECURITY_QUESTIONS_URL).then((res) => {
      dispatch(displayAvailableSecurityQuestions(res));
      callback(res.data);
    });
}

function getSecurityQuestions(username, callback) {
  const url = ApiService.substitute(SECURITY_QUESTIONS_URL, { username });

  return (dispatch) =>
    ApiService.get(url).then((res) => {
      dispatch(displaySecurityQuestions(res));
      callback(res.data);
    });
}

function saveSecurityQuestions(username, json) {
  const url = ApiService.substitute(SECURITY_QUESTIONS_URL, { username });
  const config = {
    data: JSON.stringify(json),
    headers: { 'content-type': 'application/json; charset=utf-8' },
  };

  return (dispatch) =>
    ApiService.post(url, config)
      .then((res) => {
        const resClone = [];
        resClone.data = JSON.parse(res.config.data).securityQuestions;
        dispatch(displaySecurityQuestions(resClone));

        return Promise.resolve();
      })
      .catch((err) => Promise.reject(err.response));
}

export const actionCreators = {
  getAvailableSecurityQuestions,
  getSecurityQuestions,
  saveSecurityQuestions,
};
